/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx} from "@emotion/core";
import React from 'react';


interface MapOverlayProps {
    lonLat: [number, number];
    content: any;
    projectFunc: (coords: number[]) => number[];
}


interface MapOverlayState {
}


export class MapOverlay extends React.Component<MapOverlayProps, MapOverlayState> {

    constructor(props: MapOverlayProps) {
        super(props);
        this.state = {};
    }

    render = () => {
        const position = this.props.projectFunc(this.props.lonLat);
        return (
            <div style={{position: "absolute", left: `${position[0]}px`, top: `${position[1]}px`}}>
                {this.props.content}
            </div>
        )
    }

}